import React from 'react';

const SvgRo = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="RO_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="RO_svg__b" fill="#fff">
        <use xlinkHref="#RO_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#RO_svg__a" />
      <path fill="#E5253D" mask="url(#RO_svg__b)" d="M13.333 0H28v20H13.333z" />
      <path fill="#0A3D9C" mask="url(#RO_svg__b)" d="M0 0h9.333v20H0z" />
      <path
        fill="#FFD955"
        mask="url(#RO_svg__b)"
        d="M9.333 0h9.333v20H9.333z"
      />
    </g>
  </svg>
);

export default SvgRo;
